import { Button, Card, Descriptions, Input, Space, Spin, Typography } from 'antd';
import { useFetchApiGet } from 'hooks/api/useFetchApi';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import nhsvLookupAccountApiCall from 'apps/nhsv/apiCalls/nhsv/lookup-account';
import { SearchOutlined } from '@ant-design/icons';

const { Title } = Typography;

export default function NHSVLookupAccountPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlIdNumber = searchParams.get('id_number') || '';
  const [inputValue, setInputValue] = useState(urlIdNumber);
  const { data, load, isLoading } = useFetchApiGet(nhsvLookupAccountApiCall, {
    resourceName: 'data',
  });

  useEffect(() => {
    if (urlIdNumber) {
      load({ id_number: urlIdNumber });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSearch = () => {
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    setSearchParams({ id_number: trimmed });
    load({ id_number: trimmed });
  };

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>NHSV Account Lookup by ID Number</Title>

      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Space>
          <Input
            placeholder="Enter ID number (CCCD/CMND)"
            size="large"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onPressEnter={handleSearch}
            style={{ width: 400 }}
            allowClear
          />
          <Button
            type="primary"
            size="large"
            icon={<SearchOutlined />}
            onClick={handleSearch}
            loading={isLoading}
          >
            Lookup
          </Button>
        </Space>

        {isLoading && (
          <div style={{ textAlign: 'center', padding: 48 }}>
            <Spin size="large" />
          </div>
        )}

        {data && !isLoading && (
          <Card title="NHSV Account Info" size="small">
            <Descriptions bordered column={{ xs: 1, sm: 2, lg: 3 }} size="small">
              <Descriptions.Item label="Account Number">
                {data.acnt_no ? (
                  <Link to={`/nhsv/account-detail?account_number=${data.acnt_no}`}>
                    {data.acnt_no}
                  </Link>
                ) : '-'}
              </Descriptions.Item>
              <Descriptions.Item label="Contract Number">
                {data.cntr_no || '-'}
              </Descriptions.Item>
              <Descriptions.Item label="ID Number Searched">
                {searchParams.get('id_number') || '-'}
              </Descriptions.Item>
            </Descriptions>
            {data.acnt_no && (
              <div style={{ marginTop: 16 }}>
                <Space>
                  <Link to={`/nhsv/account-detail?account_number=${data.acnt_no}`}>
                    <Button type="primary" icon={<SearchOutlined />}>View Account Detail</Button>
                  </Link>
                  <Link to={`/nhsv/order-history?account_number=${data.acnt_no}`}>
                    <Button icon={<SearchOutlined />}>View Order History</Button>
                  </Link>
                </Space>
              </div>
            )}
          </Card>
        )}
      </Space>
    </div>
  );
}
